<lib-filtered-table
  [tableId]="'schedules'"
  [tableTitle]="'request_details_screen_schedules_tab_table_title' | transloco"
  [dataSource]="dataSource()"
  [meta]="meta()"
  [columns]="columns()"
  [isLoadingData]="isLoading()"
  [showSearch]="false"
  [tableFilterTabs]="tableFilterTabs()"
  [(payload)]="payload"
  [tableColumnTemplates]="[
    { template: number },
    { template: id },
    { template: schedule_type },
    { template: next_run_at },
    { template: created_on },
    { template: end_at },
    { template: created_by },
    { template: status },
    { template: action },
  ]"
  [isTableExportable]="false"
  [applyOnStreamChanges]="checkReturnedObservable"
  (streamSucceeds)="handleSchedulesSuccess($event)"
  (handleApiCall)="handleApiCall()"
  (handleViewIconClick)="navigateToScheduleDetails($event)" />

<ng-template #number let-i="i">
  @let metaData = meta();
  @if (metaData) {
    {{ (metaData.current_page - 1) * metaData.per_page + (i + 1) }}
  }
</ng-template>

<ng-template #id let-row> #{{ row.id }} </ng-template>

<ng-template #schedule_type let-row>
  @if (
    row.schedule_type.value !== RequestScheduleType.ONE_TIME &&
    row.recurrence?.type?.label
  ) {
    <lib-badge
      [label]="row.recurrence.type.label"
      [badgeClass]="
        'px-sm border-none text-xs font-medium ' +
        (row.recurrence.type.value | status)
      " />
  } @else {
    <lib-badge
      [label]="row.schedule_type.label"
      [badgeClass]="
        'px-sm border-none text-xs font-medium ' +
        (row.schedule_type.value | status)
      " />
  }
</ng-template>

<ng-template #next_run_at let-row>
  <span dir="ltr">{{ row.next_run_at | date: 'dd-MMM-yyyy hh:mm a' }}</span>
</ng-template>

<ng-template #created_on let-row>
  <span dir="ltr">{{ row.created_at | date: 'dd-MMM-yyyy hh:mm a' }}</span>
</ng-template>

<ng-template #end_at let-row>
  @if (row.end_at) {
    <span dir="ltr">{{ row.end_at | date: 'dd-MMM-yyyy hh:mm a' }}</span>
  }
</ng-template>

<ng-template #created_by let-row>
  <div class="flex items-center gap-sm">
    <lib-avatar
      [size]="'list'"
      [fullName]="row.created_by.name"
      [img]="row.created_by.image?.url"
      borderRadius="rounded-full" />
    <span class="text-xs font-medium">{{ row.created_by.name }}</span>
  </div>
</ng-template>

<ng-template #status let-row>
  <lib-badge
    [label]="row.state.label"
    [badgeClass]="
      'px-sm border-none text-xs font-medium text-white ' +
      (row.state.value | status)
    " />
</ng-template>

<ng-template #action let-row>
  <lib-action-list
    [menuItems]="actionsList()"
    [parentName]="'schedules'"
    (menuToggled)="selectedRow.set(row)"
    (itemClick)="onActionClick($event)" />
</ng-template>

<ng-template #cancelScheduleModal>
  <lib-delete-confirmation-popup
    [deleteItemLabels]="{
      deleteItemPopupTitle: 'cancel_schedule_modal_title',
      deleteItemPopupDescription: 'cancel_schedule_modal_description',
      deleteItemPopupYesButton: 'cancel_schedule_modal_confirm_button',
      deleteItemPopupNoButton: 'cancel_schedule_modal_cancel_button',
    }"
    [isDeleteItemLoading]="isCancelling()"
    (deleteItem)="confirmCancelSchedule()"
    (closeModal)="closeCancelScheduleModal()" />
</ng-template>
